import { render, staticRenderFns } from "./v-no-content.vue?vue&type=template&id=3a18364e&"
import script from "./v-no-content.vue?vue&type=script&lang=js&"
export * from "./v-no-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports